<template>
  <v-layout row wrap my-3 mx-5>
    <v-flex xs12>
      <v-card class="pa-2 mb-5 elevation-6">
        <v-card-title class="headline white--text primary" >
          Bulk SMS
        </v-card-title>
        <v-card-actions class="px-3">
          <v-btn
              :loading="loading"
              color="primary"
              dark
              @click="pickFile ()"
              :disabled="loading"
            >
              Select File
            <v-icon right dark>cloud_upload</v-icon>
          </v-btn>
          <v-text-field
              label="file"
              v-model="name"
              readonly
              disabled
              class="mx-2"
            ></v-text-field>
            <input
              type="file"
              style="display: none"
              ref="file"
              accept="csv/*"
              @change="onFilePicked"
            >
            <v-btn
              :loading="loading"
              color="primary"
              dark
              @click="loadFile()"
            >
              Load
            <v-icon right dark>clear_all</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-spacer></v-spacer>
        </v-card-actions>
        <v-layout row wrap>
          <v-flex xs12 pa-3>
            Table should have 3 columns
            <span class="red--text">Firstname - Lastname - Number</span>
            
          </v-flex>
          <v-flex xs12 pa-3>
            <v-data-table
              :headers="detailedViewsHeaders"
              :items="detailedViews"
              class="elevation-3"
              v-model="selected"
              select-all
              item-key="Number"
            >
              <template slot="items" slot-scope="props">
                <td>
                  <v-checkbox
                    v-model="props.selected"
                    primary
                    color="primary"
                    hide-details
                  ></v-checkbox>
                </td>
                <td v-for="p in props.item" :key="p" class="text-xs-left">{{ p }}</td>
                
              </template>
            </v-data-table>
          </v-flex>
          <v-flex xs12 px-3 py-1>
            <v-select
              :items="templates"
              v-model="selectedTemplate"
              label="Load a saved Template"
              append-outer-icon="add"
              solo
              @click:append-outer="goTo('/sms-templates')"
            ></v-select>
          </v-flex>
          
        </v-layout>
        <v-card-actions class="px-3">
          <v-btn
              :loading="loading"
              color="primary"
              dark
              @click="pickFile ()"
              :disabled="loading"
            >
              Select File
            <v-icon right dark>cloud_upload</v-icon>
          </v-btn>
          <v-text-field
              label="file"
              v-model="name"
              readonly
              disabled
              class="mx-2"
            ></v-text-field>
            <input
              type="file"
              style="display: none"
              ref="file"
              accept="csv/*"
              @change="onFilePicked"
            >
            <v-btn
              :loading="loading"
              color="primary"
              dark
              @click="loadFile()"
            >
              Load
            <v-icon right dark>clear_all</v-icon>
          </v-btn>
          <v-spacer></v-spacer>
          <v-btn 
            @click="sendToAll()"  
            color="primary" 
            :loading="loading"
            dark>
          Send SMS to {{this.selected.length}} Contacts</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import Papa from 'papaparse'
import axios from 'axios';
import { uuid } from '@/customFunction';
import {firebase, db, auth} from '@/fb';


export default {
  data() {
    return {
      url:null,
      name:null,
      file:null,
      loading:false,
      sNumber:null,
      sMessage:null,
      csv:null,
      qr:null,
      messagesH:[],
      messages:[],
      detailedViewsHeaders:[],
      detailedViews:[],
      contacts:[],
      contactedNumbers:[],
      selectedNumber:null,
      selected:[],
      selectedNumberChat:null,
      chatMessages:[],
      myMSGS:[],
      clientMSGS:[],
      numbersMass:[],
      templates:[],
      loadedTemplates:null,
      selectedTemplate:null,
      selectedKey:null,
    }
  },
  methods: {
    sendToAll(){
      if (this.selected.length == 0) {
        return
      }
      this.loading = true
      let count = 0
      this.selected.forEach(contact=>{
        let sms = {
          firstname:contact.Lastname,
          lastname:contact.Firstname, 
          templatekey:this.selectedTemplate,
          number:contact.Number
        }
        console.log(sms)
        var headers = {
          'Accept': 'application/json'
        }
        axios.post(`https://hooks.zapier.com/hooks/catch/3025095/jh6zla/`, JSON.stringify(sms), {headers: headers})
        .then(resp=>{
          count++
          if (count == this.selected.length) {
            if (resp.data.status == 'success') {
              this.$emit('snackbarNotification', `Sent Successfully`, 'success')
            } else {
              this.$emit('snackbarNotification', `Sending Failed`, 'error')
            }
            this.loading = false
          }
          
        })
      })
    },
    goTo(path) {
      this.$router.push(path)
    },
    pickFile () {
      this.$refs.file.click ()
    },
    getTemplates(){
      return db.ref('sms/templates')
      .on('value', t=>{
        let templates = t.val()
        this.loadedTemplates = templates
        console.log(templates)
        for (const key in templates) {
            if (templates.hasOwnProperty(key)) {
              const template = templates[key];
              this.templates.push({
                text:template.templateName,
                value:key
              })
            }
        }
      })
    },
    loadFile(){
      this.detailedViewsHeaders = []
      this.detailedViews = []
      console.log('------------------------------------');
      console.log(this.csv);
      console.log('------------------------------------');
      this.csv.meta.fields.forEach(el => {
        this.detailedViewsHeaders.push({
          text:el,
          value:el
        })
      });
      this.detailedViews = this.csv.data
      this.numbersMass
    },
    onFilePicked (e) {
			const files = e.target.files
			if(files[0] !== undefined) {
				const fr = new FileReader ()
				fr.readAsDataURL(files[0])
				fr.addEventListener('load', () => {
          this.name = files[0].name
					this.url = fr.result
          this.file = files[0] // this is an image file that can be sent to server...
          Papa.parse(this.file, {
            header: true,
            complete: (d)=>{
              this.csv = d
            }
          })
				})
			} else {
				this.name = null
				this.fule = null
				this.url = null
			}
    },
  },
  watch:{
    selected(){
      console.log(this.selected)
    }
  },
  created() {
    this.getTemplates()
  }
}
</script>

<style>

</style>
